export default __webpack_public_path__ + "static/media/faci08.fdf0064d.jpg";